module.exports = __webpack_public_path__ + "img/18.7d3cac69.jpg";